<template>
<div>
    <div class="table-container">
        <zm-table :data="list">
            <zm-table-column prop="secretHashValue" label="secretHashValue"></zm-table-column>
            <zm-table-column prop="count" label="count" width="100px"></zm-table-column>
            <zm-table-column width="100px">
                <template slot-scope="scope">
                    <zm-button type="icon" icon="zm-icon-hide-poll" @click="showChart(scope.row.secretHashValue)"></zm-button>
                    <zm-button type="icon" icon="zm-icon-search" @click="doSearch(scope.row.secretHashValue)"></zm-button>
                </template>
            </zm-table-column>
        </zm-table>
        <div style="text-align: center" class="pagination-wrap">
            <zm-pagination @current-change="fetchData"
                @size-change="handleSizeChange"
                :current-page.sync="pagination.pageNo"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pagination.pageSize"
                layout="sizes, total, prev, pager, next, jumper"
                :total="total">
            </zm-pagination>
        </div>
        <zm-dialog :visible.sync="visible" show-close append-to-body>
            <div id="chart" style="height: 60vh"></div>
        </zm-dialog>
    </div>
</div>
</template>
<script>
import { getSameSecretStatistics, getSameSecretStatisticsByPie } from '@/api'
export default {
    name: 'hash',
    data () {
        return {
            loading: false,
            list: [],
            total: 0,
            visible: false,
            option: {
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c} ({d}%)'
                },
                series: [
                    {
                        name: 'namespace',
                        type: 'pie',
                        radius: [0, '35%'],
                        // label: {
                        //     position: 'inner'
                        // },
                        // labelLine: {
                        //     show: false
                        // },
                        data: [
                            { value: 335, name: 'dev' },
                            { value: 679, name: 'deva' },
                            { value: 1548, name: 'devb' }
                        ]
                    },
                    {
                        name: 'application',
                        type: 'pie',
                        selectedMode: 'single',
                        radius: ['65%', '75%'],
                        data: [
                            { value: 335, name: 'app1' },
                            { value: 310, name: 'app2' },
                            { value: 234, name: 'app3' },
                            { value: 135, name: 'app4' },
                            { value: 1048, name: 'app5' },
                            { value: 251, name: 'app6' },
                            { value: 147, name: 'app7' },
                            { value: 102, name: 'app8' }
                        ]
                    }
                ]
            },
            pagination: {
               pageNo: 1,
               pageSize: 10
            }
        }
    },
    created () {
        this.fetchData()
    },
    methods: {
        showChart (val) {
            this.option.series[0].data = []
            this.option.series[1].data = []
            getSameSecretStatisticsByPie(val).then(res => {
                res.data.map(namespaceData => {
                    this.option.series[0].data.push({
                        name: namespaceData.name,
                        value: namespaceData.value
                    })
                    namespaceData.children.map(appData => {
                        this.option.series[1].data.push({
                            name: appData.name,
                            value: appData.value
                        })
                    })
                })
                this.visible = true
                this.$nextTick(() => {
                    const chart1 = this.$echarts.init(document.getElementById('chart'))
                    chart1.dispose()
                    const chart = this.$echarts.init(document.getElementById('chart'))
                    chart.setOption(this.option)
                })
            })
        },
        fetchData () {
            getSameSecretStatistics(this.pagination).then(response => {
                this.list = response.data
                this.total = response.total
            })
        },
        doSearch (secretHashValue) {
            this.$router.push({
                path: '/csms/secret',
                query: { secretHashValue }
            })
        },
        handleSizeChange (val) {
            this.pagination.pageSize = val
            this.fetchData()
        }
    }
}
</script>
